import { mixins, styled } from '@bob/library'
import { Markdown } from '@websrc/App/Components/Markdown/Markdown'

export const Wrapper = styled.div`
  padding-top: 40px;
  ${mixins.margin.bottom(50)}
`

export const StyledMarkdown = styled(Markdown)`
  ${mixins.margin.top(10)}
`
